import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import ChangePasswordComponent from "../../Sections/Auth/ChangePassword_index";

const DashboardComponent = () => {
    return (
        <Dashboard sectionName={<ChangePasswordComponent />}/>
    );
};

export default DashboardComponent;
